import { exportApprovalCsvSagas } from 'modules/sheetApproval/components/ApprovalExportCsv/sagas';
import {
    getMoreApprovalSheetsSagaWatcher,
} from 'modules/sheetApproval/components/SheetApprovalInfinityTable/store/sagas';

export const sheetApprovalSagas = [
    getMoreApprovalSheetsSagaWatcher,
    ...exportApprovalCsvSagas,
];
